exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#dropzone[data-v-8973e18a] .dz-message {\n  display: flex !important;\n  justify-content: center !important;\n  width: 100% !important;\n}\n", ""]);

// exports
